<kort id="årshjul-oppsett" #kort>
  <kort-tittel>
    {{ 'Årshjul' | translate }}
    <div class="antall">{{ '{antall} innslag' | translate: {antall: innslag().length} }}</div>
  </kort-tittel>

  @if (visning()) {
    @if (!kort.erAktiv()) {
      <p>{{ 'Innslagene i årshjulet sier noe om hvilke aktiviteter som preger ulike perioder av året.' | translate }}</p>
      <kort-handlinger>
        <button mat-button (click)="visDetaljer()" data-testid="vis-alle-knapp">
          <mat-icon>list</mat-icon>
          {{ 'Vis alle' | translate }}
        </button>
      </kort-handlinger>

    } @else {
      <div class="innhold-kontainer">
        <table>
          <thead>
          <tr>
            <th>{{ 'Navn' | translate }}</th>
            <th>{{ 'Periode' | translate }}</th>
            <th class="arvet">{{ 'Arvet fra gruppemal' | translate }}</th>
          </tr>
          </thead>
          <tbody>
            @for (innslag of innslag(); track innslag.id) {
              <tr data-testid="årshjulinnslag">
                <td>
                  <div class="tittel" data-testid="navn">{{ innslag.tittel }}</div>
                  @if (innslag.beskrivelse) {
                    <html-formatert [innhold]="innslag.beskrivelse" class="beskrivelse"/>
                  }
                </td>
                <td class="periode">{{ 'Uke {startuke}, {antallUker} uker' | translate: {startuke: innslag.startuke, antallUker: innslag.antallUker} }}</td>
                <td class="arvet">
                  <mat-icon [attr.data-testid]="innslag.harForelder ? 'arvet' : null">{{ innslag.harForelder ? 'check_circle' : 'circle' }}</mat-icon>
                </td>
              </tr>
            }
          </tbody>
        </table>
        @if (viserDiagram()) {
          <aarshjul-graf-uten-moeter [data]="aarshjuldata()"/>
        }
      </div>
      <kort-handlinger>
        <div class="handlinger-venstre">
          <button mat-button (click)="skjulDetaljer()">{{ 'Skjul' | translate }}</button>
          <button mat-button (click)="rediger()" data-testid="rediger-knapp">
            <mat-icon>edit</mat-icon>
            {{ 'Rediger' | translate }}
          </button>
        </div>
        @if (viserDiagram()) {
          <button mat-button (click)="viserDiagram.set(false)">
            <mat-icon>donut_small</mat-icon>
            {{ 'Skjul diagram' | translate }}
          </button>
        } @else {
          <button mat-button (click)="viserDiagram.set(true)" data-testid="vis-diagram-knapp">
            <mat-icon>donut_small</mat-icon>
            {{ 'Vis diagram' | translate }}
          </button>
        }

      </kort-handlinger>
    }

  } @else {
    <aarshjul-innslag-rediger-liste
            [innslag]="innslag()"
            [gruppeId]="gruppeId()"
            [viserDiagram]="viserDiagram()"
            (vedFerdig)="redigeringFerdig($event)"/>
  }
</kort>
